import { Injectable } from '@angular/core'
import { Exemplo } from '../../models/Exemplo'
import { Observable } from 'rxjs'
import { concatenateUrl } from '../../../common/support/api'
import { RestService } from '../../../common/services/rest/Rest.service'
import{Endereco} from "../../../lib/models/Endereco"
const service = {
  name: 'Exemplo',
  url: 'exemplo'
}

@Injectable({
  providedIn: 'root'
})
export class EnderecoService extends RestService<Endereco> {
  private readonly API_URL = concatenateUrl(service.url)

  obterCep (cep: string): Observable<Endereco> | any {
    return this.get(`https://viacep.com.br/ws/${cep}/json/`)
  }
  


}

